/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Plan_Edit_AddInputs */

const en_us2_plan_edit_add = /** @type {(inputs: Plan_Edit_AddInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Add exercise`)
};

const pt_br2_plan_edit_add = /** @type {(inputs: Plan_Edit_AddInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Adicionar exercício`)
};

const es_419_plan_edit_add = /** @type {(inputs: Plan_Edit_AddInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Agregar ejercicio`)
};

const pt_pt2_plan_edit_add = /** @type {(inputs: Plan_Edit_AddInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Adicionar exercício`)
};

const fr_fr2_plan_edit_add = /** @type {(inputs: Plan_Edit_AddInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ajouter un exercice`)
};

const de_de2_plan_edit_add = /** @type {(inputs: Plan_Edit_AddInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Übung hinzufügen`)
};

const it_it2_plan_edit_add = /** @type {(inputs: Plan_Edit_AddInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Aggiungi esercizio`)
};

/**
* | output |
* | --- |
* | "Add exercise" |
*
* @param {Plan_Edit_AddInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const plan_edit_add = /** @type {((inputs?: Plan_Edit_AddInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Plan_Edit_AddInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_plan_edit_add(inputs)
	if (locale === "es-419") return es_419_plan_edit_add(inputs)
	if (locale === "pt-PT") return pt_pt2_plan_edit_add(inputs)
	if (locale === "fr-FR") return fr_fr2_plan_edit_add(inputs)
	if (locale === "de-DE") return de_de2_plan_edit_add(inputs)
	if (locale === "it-IT") return it_it2_plan_edit_add(inputs)
	return en_us2_plan_edit_add(inputs)
});
export { plan_edit_add as "plan-edit.add" }